import React from "react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  Button,
} from "@chakra-ui/react";

const ScratchathonDatePopover = ({ dates: { title, description } }) => {
  return (
    <Popover>
      <PopoverTrigger>
        <button className="shadow-lg bg-white hover:bg-gray-100 hover:shadow-xl duration-150 px-8 py-3 font-medium rounded-md w-full md:w-auto">
          {title}
        </button>
      </PopoverTrigger>
      <PopoverContent>
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverBody>{description}</PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default ScratchathonDatePopover;
